const filenameInfoService = {
  getMimeType: filename => {
    const extension = filenameInfoService
      .getFileExtension(filename)
      .toLowerCase()
      .trim();
    switch (extension) {
      case 'png': {
        return 'image/png';
      }
      case 'gif': {
        return 'image/gif';
      }
      case 'webp': {
        return 'image/webp';
      }
      default: {
        return 'image/jpeg';
      }
    }
  },
  getFileExtension: filename => {
    return filename.split(/[#?]/)[0].split('.').pop();
  }
};

module.exports.filenameInfoService = filenameInfoService;
